import styled from "@emotion/styled";
import { ImageProps } from "./Image.types"; // Import the prop types
import React, { useState } from "react";

const StyledImg = styled.img<ImageProps>`
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "auto"};
  object-fit: ${({ objectFit }) => objectFit || "contain"};
  border-radius: ${({ borderRadius }) => borderRadius || "0px"};
  max-height: ${({ maxHeight }) => maxHeight || "100%"};
  aspect-ratio: ${({ aspectRatio }) => aspectRatio || "auto"};
  border: ${({ border }) => border || "none"};
  cursor: ${({ onClick }) => (onClick ? "pointer" : "default")};
  background-color: ${({ bgColor }) => bgColor || "transparent"};
`;
export const StyledImage = ({
  src,
  alt,
  placeholder,
  dataCy,
  ...others
}: ImageProps) => {
  const [hasError, setHasError] = useState(false);

  const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    if (!hasError && placeholder) {
      setHasError(true);
      (e.target as HTMLImageElement).src = placeholder;
    }
  };

  return (
    <StyledImg
      src={src}
      alt={alt}
      onError={handleError}
      data-cy={dataCy}
      {...others}
    />
  );
};
